import LogoutIcon from '@mui/icons-material/Logout'
import SettingsIcon from '@mui/icons-material/Settings'
import { IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { useTranslate, useLogout } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import { themeColor } from './themes'

export const UserMenu: FC = () => {
  const translate = useTranslate()
  const logout = useLogout()
  const navigate = useNavigate()

  const handleLogout = () => void logout()

  return (
    <Root>
      <IconButton
        aria-label={translate('settings.title')}
        color="inherit"
        onClick={() => navigate('/settings')}
      >
        <SettingsIcon sx={{ color: themeColor.blue }} />
      </IconButton>
      <IconButton
        aria-label={translate('ra.auth.user_menu')}
        aria-haspopup={true}
        color="inherit"
        onClick={handleLogout}
      >
        <LogoutIcon sx={{ color: themeColor.blue }} />
      </IconButton>
    </Root>
  )
}

const Root = styled('div')(({ theme }) => ({
  ['& span']: {
    marginRight: '5px',
  },
}))
